// extracted by mini-css-extract-plugin
export var bottom = "fc-content-highlight-module--bottom--d492d";
export var copy = "fc-content-highlight-module--copy--32d69";
export var image = "fc-content-highlight-module--image--77efe";
export var root = "fc-content-highlight-module--root--266ad";
export var subtitle = "fc-content-highlight-module--subtitle--a0ce3";
export var text = "fc-content-highlight-module--text--78b9c";
export var title = "fc-content-highlight-module--title--ef6c4";